"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = exports.TimeUnit = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Canceled"] = "CANCELED";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["Expired"] = "EXPIRED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["Minutes"] = 60000] = "Minutes";
    TimeUnit[TimeUnit["Hours"] = 3600000] = "Hours";
    TimeUnit[TimeUnit["Weeks"] = 604800000] = "Weeks";
    TimeUnit[TimeUnit["Days"] = 86400000] = "Days";
    TimeUnit[TimeUnit["Months"] = 2592000000] = "Months";
    TimeUnit[TimeUnit["Years"] = 31536000000] = "Years";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var OrderType;
(function (OrderType) {
    OrderType["LIMIT"] = "limit";
    OrderType["TWAP_LIMIT"] = "twap-limit";
    OrderType["TWAP_MARKET"] = "twap-market";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
